<template>
  <div class="echarts-image-frame-wrapper">
    <div v-show="!isEmpty" class="echarts-image-info">暂无数据</div>
    <div v-show="isEmpty" class="echarts-image-frame-time">
      <el-select v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div v-show="isEmpty" class="echarts-image-frame" v-charts></div>
  </div>
</template>
<script>
import e4parent from "@/components/charts/e4parent";
export default {
  data() {
    return {
      options: [
        {
          value: "1",
          label: "全A股",
        },
        {
          value: "2",
          label: "A股-本行业",
        },
      ],
      value: "1",
    };
  },
  extends: e4parent,
  props: {},
  methods: {
    /* setOption() {
      this.isEmpty = true;
      this.$nextTick(() => {
        this.render(this.getMockData());
      });
    },  */
    getFormatExParams() {
      let isAll = this.value - 1;

      return {
        isAll,
      };
    },
    getMockData() {
      let res = {
        data: [
          {
            value: 100,
            name: "未入章",
          },
          {
            value: 200,
            name: "已入章1",
          },
          {
            value: 200,
            name: "已入章2",
          },
          {
            value: 200,
            name: "已入章3",
          },
          {
            value: 200,
            name: "已入章4",
          },
        ],
      };
      return res;
    },
    getLegendData: function (data) {
      let legendData = [];
      let len = data.length;
      for (let i = 0; i < len; i++) {
        let item = data[i];
        let name = item.name;
        legendData.unshift(name);
      }
      return legendData;
    },
    packageData: function (res) {
      // let title = this.title;
      let colorData = this.colorData;
      if (res.code && res.code == 200) {
        var seriesX = this.formData(res.data, "sec");
        var seriesY = this.formData(res.data, "total_num");
      } else {
        this.$message.closeAll();
        this.$message({
          message: "查找数据出错",
          type: "error",
          showClose: true,
        });
      }
      let seriesData = { seriesX: seriesX, seriesY: seriesY };

      // let legendData = this.getLegendData(seriesData);
      return {
        // title: title,
        // legendData: legendData,
        seriesData: seriesData,
        colorData: colorData,
      };
    },
    formData(v, m) {
      let arr = [];
      for (var i = 0; i <= v.length - 1; i++) {
        arr.push(v[i][m]);
      }
      return arr;
    },
    getEchartsOptions(res) {
      let data = this.packageData(res);
      let colorData = data.colorData;
      let option = {
        color: colorData,
        /* grid: {
          top: "10%",
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        }, */
        grid: [{ x: "15%", y: "10%", width: "85%", height: "80%" }],

        xAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#f0f0f0",
              opacity: 0.5,
            },
          },
          axisLabel: {
            show: true,
            color: this.chartsLabelColor || "#333333",
          },
          data: data.seriesData.seriesX,
        },
        yAxis: {
          // name: units,
          type: "value",
          minInterval: 1,
          nameTextStyle: {
            color: this.chartsLabelColor || "#333333",
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#f0f0f0",
              opacity: 0.5,
            },
          },
          axisLabel: {
            show: true,
            color: this.chartsLabelColor || "#333333",
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#f0f0f0",
              opacity: 0.5,
            },
          },
        },
        series: [
          {
            stack: 1,
            type: "bar",
            // name: name,
            barWidth: 20,
            data: data.seriesData.seriesY,
          },
        ],
      };
      return option;
    },
  },
  watch: {
    value(val) {
      this.loadTimer && clearTimeout(this.loadTimer);
      this.loadTimer = setTimeout(() => {
        this.setOption();
      }, 200);
    },
  },
};
</script>

<style scoped lang="scss">
.echarts-image-frame-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.echarts-image-frame {
  width: 100%;
  height: calc(100% - 30px);
  overflow: hidden;
}
.echarts-image-frame-wrapper {
  position: relative;
}
.echarts-image-info {
  position: absolute;
  text-align: center;
  top: 50%;
  left: 0;
  right: 0;
  transform: translate(0, -50%);
  color: #909399;
  font-size: 14px;
}
.echarts-image-frame-time {
  text-align: right;
}
/deep/.el-input__inner {
  font-size: 10px;
}
/deep/.el-input--suffix .el-input__inner {
  padding-right: 0px;
}
</style>
